<template>
  <!-- 工单详情 -->
  <div class="smy__card-full-box">
    <Card class="" :bordered="false" :padding="0">
      <p slot="title">客户详情</p>
    </Card>
    <div class="content">
      <Card class="smy__card-full card-left" :bordered="false">
        <FollowDetailLeft
          :followDetail="followLeftDetail"
          @callback="getList()"
          @recharge="recharge"
        />
      </Card>
      <div class="smy__card-full card-right">
        <Card :bordered="false">
          <FollowDetailTop
            ref="followDetailTop"
            :followDetail="followLeftDetail"
            @callback="getList()"
            @recordCallback="getFollowLeftDetail"
          />
        </Card>
        <Card style="margin-top: 10px" :bordered="false">
          <FollowDetailRight
            ref="followDetailRight"
            :followDetail="followDetail"
          />
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'
import FollowDetailLeft from './FollowDetailLeft'
import FollowDetailRight from './FollowDetailRight'
import FollowDetailTop from './FollowDetailTop'

export default {
  components: {
    FollowDetailLeft,
    FollowDetailRight,
    FollowDetailTop,
  },
  props: {
    orderId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      followLeftDetail: {},
      followDetail: [],
      epId: this.id,
      pageIndex: 0,
      pageSize: 10,
      count: '',
      phoneCount: '',
    }
  },
  computed: {
    ...mapState('table', ['isShowApproveBtn']),
    ...mapState('followCustom', ['id']),
  },
  methods: {
    ...mapMutations('table', ['_isShowApproveBtn']),
    ...mapMutations('followCustom', ['_id']),
    recharge(e) {
      this.$refs.followDetailTop.editBtn(...e)
    },
    getList() {
      this.$http.get('/enterprise/mgr/info/' + this.id).then((res) => {
        this.followLeftDetail = res.data
      })
    },
    getFollowLeftDetail() {
      this.$http
        .get('/enterprise/followup/list', {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            epId: this.id,
          },
        })
        .then((res) => {
          this.followDetail = res.data
        })
    },
    //  back () {
    //    this.$router.back()
    //  }
  },
  created() {
    this._id(this.orderId)
    //  跟进记录
    this.$http
      .get('/enterprise/followup/list', {
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          epId: this.id,
        },
      })
      .then((res) => {
        this.followDetail = res.data
      })
    //  跟进记录数量
    this.$http
      .get('/enterprise/followup/count', {
        params: {
          epId: this.id,
        },
      })
      .then((res) => {
        this.count = res.data
      })
  },
  beforeRouteEnter(to, from, next) {
    //  客户详情
    axios.get(`/enterprise/mgr/info/${to.params.orderId}`).then((res) => {
      next((vm) => {
        vm.followLeftDetail = res.data
      })
    })
  },
  beforeDestroy() {
    this._isShowApproveBtn(false)
  },
}
</script>

<style lang="less" scoped>
.content {
  margin-top: 10px;
  flex: 1;
  display: flex;

  .card-left {
    width: 300px;
    height: 100%;
    flex-shrink: 0;
  }

  .card-right {
    width: 100%;
    margin-left: 10px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/cusFollowDetail/FollowDetail.vue